module.exports = __webpack_public_path__ + "io.5484cb8b086cc77919fc.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/io.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/io.svg
// module chunks = styles